<template>
  <CadastroBase
    nomePlural="FuncionarioPreContratracaoDocumentos"
    nomeSingular="FuncionarioPreContratracaoDocumentos"
    @submitSuccessInsert="emitSubmitSuccess"
    @submitErrorInsert="emitSubmitError"
    @closeModalInsert="closeModal"
  >
    <v-col cols="12" md="12">
      <v-text-field
        v-model="recurso.descricao"
        :label="$t('Descricao')"
        name="descricao"
        obrigatorio
        class="
          input-style
          font-size-input
          text-light-input
          placeholder-light
          input-icon
        "
        dense
        flat
        filled
        solo
      >
      </v-text-field>
    </v-col>
    <v-col cols="12" md="4">
      <v-checkbox v-model="recurso.obrigatorio">
        <template v-slot:label>
          {{ $t("Obrigatorio") }}
        </template>
      </v-checkbox>
    </v-col>
    <v-col cols="12" md="4">
      <v-checkbox v-model="recurso.obrigatorioSexoMasculino">
        <template v-slot:label>
          {{ $t("Obrigatorio_para_masculino") }}
        </template>
      </v-checkbox>
    </v-col>
    <v-col cols="12" md="4">
      <v-checkbox v-model="recurso.obrigatorioSexoFeminino">
        <template v-slot:label>
          {{ $t("Obrigatorio_para_feminino") }}
        </template>
      </v-checkbox>
    </v-col>
    <v-col cols="12" md="4">
      <v-checkbox v-model="recurso.obrigatorioNivelSuperior">
        <template v-slot:label>
          {{ $t("Obrigatorio_para_nivel_superior") }}
        </template>
      </v-checkbox>
    </v-col>
    <v-col cols="12" md="4">
      <v-checkbox v-model="recurso.obrigatorioNivelNaoSuperior">
        <template v-slot:label>
          {{ $t("Obrigatorio_para_nivel_nao_superior") }}
        </template>
      </v-checkbox>
    </v-col>
  </CadastroBase>
</template>

<script>
import CadastroBase from "@/components/base/Crud/CadastroBase";
import DataService from "@/services/pessoal/FuncionarioPreContratracaoDocumentosDataService";

export default {
  name: "CadastroFuncionarioPreContratracaoDocumentos",
  components: { CadastroBase },
  data() {
    return {
      DataService,
      recurso: {
        obrigatorio: true,
        obrigatorioSexoMasculino: true,
        obrigatorioSexoFeminino: true,
        obrigatorioNivelSuperior: false,
        obrigatorioNivelNaoSuperior: false,
        statusComum: "ATIVO",
      },
      errors: [],
    };
  },
  methods: {
    emitSubmitSuccess() {
      this.$emit("submitSuccessInsert");
    },
    emitSubmitError() {
      this.$emit("submitErrorInsert");
    },
    closeModal() {
      this.$emit("closeModalInsert");
    },
  },
};
</script>

<style scoped></style>
